import { render } from "./App.vue?vue&type=template&id=cc6cc1a4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=cc6cc1a4&lang=less"

import exportComponent from "/Users/aleksandrzulaev/Sites/Landings/appsguru.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__